import React, { useState, useRef, useEffect } from "react";
import CssTransition from "./layout/css-transition";

function DashboardPopOver({ handleOnClick, menus, isDisable }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const trigger = useRef(null);
  const dropdown = useRef(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  return (
    <div className="relative">
      <span
        ref={trigger}
        className="fa-solid fa-ellipsis text-base text-[#7D8490] cursor-pointer"
        onClick={(e) => {
          e.stopPropagation()
          setDropdownOpen(!dropdownOpen)
        }}
      ></span>
      <CssTransition
        show={dropdownOpen}
        tag="div"
        className="w-[150px] bg-white absolute top-full left-0 transform -translate-x-[90%] p-2 rounded shadow-md z-60"
        enter="transition ease-out duration-100 transform"
        enterStart="opacity-0 -translate-y-2"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
      >
        <div
          ref={dropdown}
          className="font-medium text-sm text-slate-600 space-y-2 !z-[1000]"
          onFocus={() => setDropdownOpen(true)}
        >
          <div className="space-y-1 !z-[1000]">
            <div className="space-y-1">
              {menus.map((item) => (
                <div className="mr-1">
                  <div
                    onClick={(e) => {
                      setDropdownOpen(false);
                      e.stopPropagation();
                      handleOnClick();
                    }}
                    className={`p-[2px] ${isDisable ? "text-slate-400 pointer-events-none" : "text-[#535860]"}  hover:bg-[--bg-color-50]] hover:font-medium hover:text-[--bg-color-900] cursor-pointer`}
                  >
                    <h6 className="text-xs font-medium cursor-pointer">{item}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </CssTransition>
    </div>
  );
}

export default DashboardPopOver;
